"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hyperIndicesField = exports.hyperIndex = void 0;
var hyperIndex;
(function (hyperIndex) {
    hyperIndex["idxHyperDocumentType"] = "idx-hyper_document_type";
    hyperIndex["idxAccount"] = "idx-account";
})(hyperIndex || (exports.hyperIndex = hyperIndex = {}));
exports.hyperIndicesField = [
    {
        fields: ['hyper_document_type'],
        name: hyperIndex.idxHyperDocumentType
    },
    {
        fields: ['account', 'hyper_document_type'],
        name: hyperIndex.idxAccount
    }
];
